/* eslint-disable react/no-unescaped-entities */
import React from "react";
import Modal from "../../components/ui/Modal";

export const ContentModal = ({
  isTermsModalOpen,
  setIsTermsModalOpen,
  contentData,
}: {
  isTermsModalOpen: boolean;
  setIsTermsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contentData: any;
}) => {
  return (
    <Modal
      modalClass="!pt-4 md:pr-11 !rounded max-h-[100%] sm:max-h-[90%] overflow-scroll lg:!w-10/12 !w-full"
      headerClass="mt-2 bg-red sticky py-8 left-8 right-20 -top-6 bg-white font-bold text-2xl"
      // header={modalTitle ? modalTitle : "Terms and Conditions"}
      visible={isTermsModalOpen}
      closeHandler={() => setIsTermsModalOpen(false)}
    >
      <div className="flex flex-col justify-between w-full h-full">
        {contentData?.map((part: any, idx: number) => (
          <div
            key={idx}
            className={`flex flex-col gap-2 ${idx === 0 ? " py-[45px]" : " py-[18px]"} max-md:p-5`}
          >
            {/* Title */}
            <p className="text-black text-2xl font-semibold leading-6 tracking-[0.24px] max-md:text-sm">
              {part?.title}
            </p>

            {/* Description */}
            {!part?.links && (
              <p className="text-black text-base font-normal leading-6 tracking-[0.16px] max-md:text-xs">
                {part?.description}
              </p>
            )}

            {/* === PART A: Remittance Partners === */}
            {part?.partners && (
              <div className="mt-6 overflow-x-auto flex justify-center items-center max-md:justify-start">
                <table className="w-full max-w-[843px] border border-gray-300 bg-white text-[#868686] border-collapse text-left">
                  <thead className="bg-white">
                    <tr>
                      <th className="border border-gray-300 px-4 py-2 font-semibold text-[#282A30] text-xs w-[200px]">
                        Remittance Partner
                      </th>
                      <th className="border border-gray-300 px-4 py-2 font-semibold text-[#282A30] text-xs">
                        Partner License Category
                      </th>
                      <th className="border border-gray-300 px-4 py-2 font-semibold text-[#282A30] text-xs">
                        Partner License
                      </th>
                      <th className="border border-gray-300 px-4 py-2 font-semibold text-[#282A30] text-xs">
                        Purpose Code
                      </th>
                      <th className="border border-gray-300 px-4 py-2 font-semibold text-[#282A30] text-xs">
                        Estimated timeline for remittance
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {part?.partners?.map((partner: any, pIdx: number) => (
                      <tr key={pIdx}>
                        <td className="border border-gray-300 px-4 py-3 align-top whitespace-nowrap font-medium text-xs">
                          {partner?.name}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-top whitespace-nowrap text-xs">
                          {partner?.licenseCategory}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-top whitespace-nowrap text-xs">
                          {partner?.licenseNumber}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-top whitespace-nowrap text-xs">
                          {partner?.purposeCodes?.map((pc: string, i: number) => (
                            <p key={i}>{pc}</p>
                          ))}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-top whitespace-nowrap text-xs">
                          {partner?.estimatedTimeline}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* === PART B: Grievance Redressal (Companies) === */}
            {part?.companies && (
              <div className="mt-6 overflow-x-auto flex items-center max-md:justify-start">
                <table className="w-full max-w-[843px] border border-gray-300 bg-white text-[#868686] border-collapse text-left">
                  <thead>
                    <tr className="bg-[#FFF] text-[#868686]">
                      <th className="border border-gray-300 px-4 py-2 w-[200px]"></th>
                      {part?.companies?.map((company: any, cIdx: number) => (
                        <th key={cIdx} className="border border-gray-300 px-4 py-2">
                          {company?.name}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-[#FFF] text-[#868686]">
                    {(() => {
                      const maxLevels = Math.max(
                        ...(part?.companies?.map((c: any) => c.levels?.length || 0) || [0])
                      );

                      return Array.from({ length: maxLevels }).map((_, levelIdx) => (
                        <tr key={levelIdx}>
                          <td className="border border-gray-300 px-4 py-3 font-normal whitespace-nowrap">
                            {
                              part?.companies?.find((c: any) => c.levels?.[levelIdx])?.levels?.[
                                levelIdx
                              ]?.level
                            }
                          </td>

                          {part?.companies?.map((company: any, cIdx: number) => {
                            const level = company?.levels?.[levelIdx];
                            const contact = level?.contacts;

                            return (
                              <td key={cIdx} className="border border-gray-300 px-4 py-3">
                                {contact ? (
                                  <>
                                    {contact?.title && <p>{contact.title}</p>}
                                    {contact?.subtitle && <p>{contact.subtitle}</p>}
                                    {contact?.email && (
                                      <p className="underline text-blue-600">
                                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                      </p>
                                    )}
                                    {contact?.phone && <p>{contact.phone}</p>}
                                  </>
                                ) : (
                                  <p>-</p>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      ));
                    })()}
                  </tbody>
                </table>
              </div>
            )}

            {/* === PART F: RBI-CMS Links === */}
            {part?.links && (
              <p className="text-black text-base font-normal leading-6 tracking-[0.16px] max-md:text-xs">
                {part?.description} (
                <a
                  href={part?.links?.[0]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 underline hover:text-blue-500"
                >
                  {part?.links?.[0]}
                </a>
                ) or (
                <a
                  href={part?.links?.[1]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 underline hover:text-blue-500"
                >
                  {part?.links?.[1]}
                </a>
                ).
              </p>
            )}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ContentModal;
